import { useFieldArray } from 'react-hook-form';
import InputLabel from '../../components/InputLabel/InputLabel';

export default function InternalNotesFieldArray({ register, control, errors }) {
  const {
    fields: InternalNotesFields,
    append: InternalNotesAppend,
    remove: InternalNotesRemove,
  } = useFieldArray({
    control,
    name: `internal_notes`,
  });

  const onClickAddInternalNotes = () => {
    InternalNotesAppend({});
  };

  return (
    <div>
      {InternalNotesFields.map((item, notesindex) => {
        return (
          <div key={item.id} className={`${notesindex !== 0 ? 'mt-2' : ''}`}>
            <div className="flex items-center w-full">
              <div className="w-full flex flex-col gap-2">
                <label className={'font-[system-ui] text-[#60657B] opacity-50 text-xs font-normal'}>
                  {'Internal Note'}
                </label>
                <textarea
                  rows={7}
                  className="p-[14px] outline-none w-full border"
                  {...register(`internal_notes.${notesindex}.note`)}
                />
                {notesindex >= 1 && (
                <section className="mt-1">
                <button className="text-[#2B2D38] opacity-50 text-base" type="button" onClick={() => InternalNotesRemove(notesindex)}>
                  X Remove Note
                </button>
              </section>
              )}
              </div>
              
            </div>
            {notesindex === 0 && (
              <section className="mt-1">
                <button className="text-[#2B2D38] opacity-50 text-base" type="button" onClick={onClickAddInternalNotes}>
                  + Add Internal Note
                </button>
              </section>
            )}
          </div>
        );
      })}
    </div>
  );
}
